module.exports = __webpack_public_path__ + "static/media/ezifit-rear.f819e8be.jpg";